/* eslint-disable react-hooks/rules-of-hooks */
import { Card } from 'components/Card';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { format } from 'date-fns';
import { useEsc } from 'hooks/useEsc';
import { useSelector } from 'hooks/useSelector';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK } from 'store/actions';
import {
  selectAseActionAstAse,
  selectAseControlAstAse,
} from 'store/assessments/selectors';
import { AssessmentItemTypes } from 'store/assessments/types';
import { ListItem } from './ListItem';
import { PageHeader } from 'components/PageHeader';

export const HistoryScreen: React.FC<
  ModalScreenProps<ModalScreens.ASEHISTORY>
> = ({ route }) => {
  const dispatch = useDispatch();
  const { findingType, id } = route.params;
  const finding =
    findingType === AssessmentItemTypes.ACTION
      ? useSelector((state) => selectAseActionAstAse(state, id))!
      : useSelector((state) => selectAseControlAstAse(state, id))!;

  const data = finding.history
    .slice()
    .map((item, index) => ({
      id: index,
      by: item.by.name,
      comment: item.comment,
      date: item.ts ? format(new Date(item.ts * 1000), 'dd/MM/yyyy') : null,
      status: item.status?.name || null,
      statusType: !index
        ? 'Identified in Assessment'
        : item.statusConfirmed
          ? 'Reviewed in Assessment'
          : null,
    }))
    .reverse();

  useEsc(() => dispatch(NAVIGATE_MODAL_BACK()));

  return (
    <Page
      scrollView
      header={
        <PageHeader
          title={
            findingType === AssessmentItemTypes.ACTION
              ? 'Action History'
              : 'Control History'
          }
          onPressCloseButton={() => dispatch(NAVIGATE_MODAL_BACK())}
        />
      }
    >
      <Card>
        {data.map((item) => (
          <ListItem key={item.id} item={item} />
        ))}
      </Card>
    </Page>
  );
};
